import React from 'react';
import * as R from 'ramda';
import { defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { string, func } from 'prop-types';
import Menu, { MenuItem } from 'common/mdc/menu';
import WithDialog from 'common/mdc/dialog/withDialog';
import { withConfirmationDialog } from 'common/mdc/dialog';
import { actions as purgeActions } from '@sma/store/job/jobs';
import DeletingDialog from './deletingDialog';
import JobShape from './shape';

const messages = defineMessages({
  onDetails: {
    id: 'table.actions.onDetails',
    defaultMessage: 'Details',
  },
  cancel: {
    id: 'table.actions.cancelJob',
    defaultMessage: 'Cancel Job',
  },
});

const JobTableActions = ({
  job,
  deletingDialog,
  ping,
  purge,
  ...props
}, {
  onDetails,
}) => (
  <Menu {...props}>
    {job && (
      <MenuItem
        key={messages.onDetails.id}
        onClick={() => onDetails({
          jobId: job.jobId + '',
        })}
      >
        <p>Job Details</p>
      </MenuItem>
    )}
    {job && (job.status === "RUNNING" || job.status === "SCHEDULED" || job.status === "NONE") && (
      <MenuItem key={messages.cancel.id}
      onClick={() => deletingDialog({
        resolve: () => purge(job.jobName),
        jobId: job.jobName,
      })}
    >
      <FormattedMessage {...messages.cancel} />
    </MenuItem>
    )}
    
  </Menu>
);

JobTableActions.propTypes = {
  job: JobShape.isRequired,
  purge: func.isRequired
};

export default R.compose(
  connect(
    null,
    {
      purge: purgeActions.purge
    },
  ),
  withConfirmationDialog(DeletingDialog, 'deletingDialog', true),
)(JobTableActions);
